module.exports = "/images/cross.svg?6bbbc31d88525a29d6a714faff934091";


//////////////////
// WEBPACK FOOTER
// ./resources/images/cross.svg
// module id = ./resources/images/cross.svg
// module chunks = 0